export { SitemapView as default } from './SitemapView';
